import React, { useEffect, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
import { BiSearch } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import useDebounce from "../../CustomHooks/useDebounce";
import "./SubSearchBar.css";

export const MIN_SEARCH_LENGTH = 3;


const SubSearchBar = ({ placeholder = "Search medicines", onSearch }) => {
  const [value, setValue] = useState("");
  const appliedRef = useRef("");
  const inputRef = useRef(null);

  const apply = (text) => {
    const trimmed = text.trim();
    const next = trimmed.length >= MIN_SEARCH_LENGTH ? trimmed : "";
    if (next === appliedRef.current) return;
    appliedRef.current = next;

    unstable_batchedUpdates(() => onSearch(next));
  };

  const debouncedApply = useDebounce(apply, 500, [onSearch]);

  useEffect(() => () => debouncedApply.cancel(), [debouncedApply]);

  const handleChange = (e) => {
    setValue(e.target.value);
    debouncedApply(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.stopPropagation();
      debouncedApply.cancel();
      apply(value);
    } else if (e.keyCode === 27 && value) {
      handleClear();
    }
  };

  const handleClear = () => {
    setValue("");
    debouncedApply.cancel();
    apply("");
    inputRef.current && inputRef.current.focus();
  };

  const trimmedLength = value.trim().length;
  const showHint = trimmedLength > 0 && trimmedLength < MIN_SEARCH_LENGTH;

  return (
    <div className="sub_search_div">
      <div className={`sub_search_box${value ? " sub_search_box_active" : ""}`}>
        <BiSearch className="sub_search_icon" aria-hidden="true" />
        <input
          ref={inputRef}
          type="text"
          className="sub_search_input font_ubuntu"
          placeholder={placeholder}
          aria-label={placeholder}
          spellCheck="false"
          autoComplete="off"
          value={value}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
        />
        {value && (
          <button
            type="button"
            className="sub_search_clear"
            aria-label="Clear search"
            onClick={handleClear}
          >
            <IoClose />
          </button>
        )}
      </div>
      {showHint && (
        <p className="sub_search_hint font_ubuntu">
          Type at least {MIN_SEARCH_LENGTH} letters to search
        </p>
      )}
    </div>
  );
};

export default SubSearchBar;
